module.exports = __webpack_public_path__ + "IDay-3a74685445c7903e8215.png";